import { baseConfig } from './base.config';
import { Config } from './config.interface';

export const productionConfig: Config = {
  ...baseConfig,
  contracts: {
    usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    phnm: '0x35d4F6D876d6c14775DF8A74b8dE3A699cF458AC',
    tables: '0x37AEFbD92631Ed932f1C1ed355fAc8d2a8EC68DC',
    revenueShareManager: '0x4A11f00a28B718c6b3360484E1f21772B1c4c4a5',
    rakeManager: '0xF850a3463736a26873146fbC26d634030E1d88b0',
    redemptionManager: '0xD6Bb3F4576f341Bbc8DbC9d0a302205C643783a8',
    redemptionVault: '0x937b54FD8952A1226CA06591f2b5723A946f3079',
    rewardsManager: '0xa6c8bDDf6108a004749ed4E437B1bAF9Eb9E9318',
    safeTreasury: '0x7b06962E7DdCdfC961C995f50dBd1BbF2020800E',
    orchestrator: '0x276d28120Bc89FDFf8E52f23B025A2cb53615e0A',
    redemption: '0x270938Eda112d07c09476f071F7675B13D311A5D',
    smartWallet: '0xA3f501efa06457e1d16a6ce0E9c7aAA7cCb347B7',
    poolAccount: '0x43a8cD5887011640f77FF47345F48eCFa986c31C',
    leaderboard: '0xC721B7981d1b73F4d08c860fFb65853591DB2946',
    tournaments: '0x61E99b7357c75182B4f87b7045d8b41110b793a8',
    tournamentFactory: '0xa02d7ed72134e21Fd0F80B169398a811196dAba2',
    backendDeployer: '0x3814F5029f09D197e9DCFc23f01Fbe4de3503F41',
    ticket: '0x389cf803849C353A853BF1bD405277403d84d85f',
    tournamentRakeManager: '0xB9675b9bA9f439738065440E8e93e86538DE22D6',
  },
  blockchain: {
    providers: {
      tenderly: {
        url: 'https://polygon.gateway.tenderly.co/5mdAIQlPPzdFYNdblmELyx',
        wss: 'wss://polygon.gateway.tenderly.co/5mdAIQlPPzdFYNdblmELyx',
      },
      quickNode: {
        url: 'https://side-damp-spree.matic.quiknode.pro/787fca9d6bc053f7aacff150f391ef28b3677666',
        wss: 'wss://side-damp-spree.matic.quiknode.pro/787fca9d6bc053f7aacff150f391ef28b3677666',
      },
    },
    explorerUrl: 'https://polygonscan.com',
    chainId: 137,
    usdtDecimals: 6,
    phnmDecimals: 18,
  },
  posthogPublicApiKey: 'phc_WR9OCd9XpGSuUYK0byJM8Ujianct37Jz7w02sZAsTHD',
  tenderly: {
    accountSlug: 'phenom_poker',
    projectSlug: 'backend-production',
  },
  urls: {
    app: 'https://play.phenompoker.com',
    admin: 'https://admin.phenompoker.com',
    landing: 'https://phenompoker.com',
    otherCorsOrigins: ['https://www.phenompoker.com', 'https://project-qiszqjboltunjhxnouee.framercanvas.com'],
    desktopClientDownloadPrefix: 'https://assets.phenompoker.com/desktop-client/Phenom%20Poker',
  },
};
